module.exports = __webpack_public_path__ + "static/media/OE-Leonie-schema_adaptif-en.077a851d.jpg";